/* Coundown */
$(document).ready(function () {

  // countDownDataRaw =  $(".countdown-hero__count-container").data("countdown"); // 06/21/24 00:00 am
  
  // countDownDate = countDownDataRaw
  // var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // var end = moment.tz(countDownDate, 'MM/DD/YY hh:mm a', userTimeZone); 
  // var _second = 1000; 
  // var _minute = _second * 60;
  // var _hour = _minute * 60;
  // var _day = _hour * 24;
  // var timer;

  // function showRemaining() {
    
    
  //   var now = moment.tz(userTimeZone);
  //   var distance = end.diff(now);

  //   // var distance = -1;
  //   if (distance < 0) {
  //     clearInterval(timer);
  //     $(".countdown-hero__count-container-content").addClass(
  //       "count-down-ended"
  //     );
  //     // document.getElementById('countdown').fadeOut();
  //     return;
  //   }
  //   var days = Math.floor(distance / _day);
  //   var hours = Math.floor((distance % _day) / _hour);
  //   var minutes = Math.floor((distance % _hour) / _minute);
  //   var seconds = Math.floor((distance % _minute) / _second);
  //   document.getElementById("countdown").innerHTML =
  //     '<div><p class="number">' + days + "</p> <p>days</p> </div> ";
  //   document.getElementById("countdown").innerHTML +=
  //     '<div><p class="number">' + hours + "</p> <p>hrs</p></div> ";
  //   document.getElementById("countdown").innerHTML +=
  //     '<div><p class="number">' + minutes + "</p><p>mins</p></div> ";
  //   document.getElementById("countdown").innerHTML +=
  //     '<div><p class="number">' + seconds + " </p><p>secs</p>";
  // }

  
  countDownDataRaw = $(".countdown-hero__count-container").data("countdown"); 
  var offset = new Date().getTimezoneOffset();
  countDownDate = countDownDataRaw
   var end = moment.tz(countDownDate, 'MM/DD/YYYY hh:mm a', 'Europe/London');
 // var end = moment.tz(countDownDate, 'MM/DD/YY hh:mm a', 'Europe/London'); 
  var _second = 1000; 
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;

  function showRemaining() {
    var now = moment.tz('Europe/London');
    var distance = end.diff(now);
    
    // var distance = -1;
    if (distance < 0) {
      clearInterval(timer);
      $(".countdown-hero__count-container-content").addClass(
        "count-down-ended"
      );
      // document.getElementById('countdown').fadeOut();
      return;
    }
    var days = Math.floor(distance / _day);
    var hours = Math.floor((distance % _day) / _hour);
    var minutes = Math.floor((distance % _hour) / _minute);
    var seconds = Math.floor((distance % _minute) / _second);
    document.getElementById("countdown").innerHTML =
      '<div><p class="number">' + days + "</p> <p>days</p> </div> ";
    document.getElementById("countdown").innerHTML +=
      '<div><p class="number">' + hours + "</p> <p>hrs</p></div> ";
    document.getElementById("countdown").innerHTML +=
      '<div><p class="number">' + minutes + "</p><p>mins</p></div> ";
    document.getElementById("countdown").innerHTML +=
      '<div><p class="number">' + seconds + " </p><p>secs</p>";
  }
  timer = setInterval(showRemaining, 1000);

  $(
    ".countdown-hero .countdown-hero__count-container-content .inactive-stock, .join-mailing-list"
  ).on("click", function () {
    $("html, body").animate({ scrollTop: $(document).height() }, "slow");
  });

  if ($(document).find(".countdown-hero__slider-inside")) {
    $(".countdown-hero__slider-inside").slick({
      appendArrows: $(".countdown-hero__slider-buttons"),
      dots: true,
      appendDots: $(".countdown-hero__slider-buttons"),
      prevArrow:
        '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10 fa-5x"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10 fa-5x"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>',
    });
  }
});

/* Footer fb messenger */
// window.fbAsyncInit = function () {
//   FB.init({
//     xfbml: true,
//     version: "v10.0",
//   });
// };

// (function (d, s, id) {
//   var js,
//     fjs = d.getElementsByTagName(s)[0];
//   if (d.getElementById(id)) return;
//   js = d.createElement(s);
//   js.id = id;
//   js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
//   fjs.parentNode.insertBefore(js, fjs);
// })(document, "script", "facebook-jssdk");

/* Footer visibel class */
$(document).ready(function() {
    // Function to check if Facebook chat plugin is visible
    function isFBChatPluginVisible() {
        var rect = $('.site-footer').get(0).getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    // Function to check if footer is visible
    function isFooterVisible() {
        var rect = $('footer').get(0).getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    // Function to add or remove active-footer class based on visibility
    function toggleActiveFooterClass() {
        if (isFBChatPluginVisible() || isFooterVisible()) {
            $('body').addClass('active-footer');
        } else {
            $('body').removeClass('active-footer');
        }
    }

    // Initial check and event listener for scroll or resize
    toggleActiveFooterClass();
    $(window).on('scroll resize', toggleActiveFooterClass);
});

// Initial check and event listener for scroll or resize
toggleActiveFooterClass();
window.addEventListener('scroll', toggleActiveFooterClass);
window.addEventListener('resize', toggleActiveFooterClass);
/* Header menu */
$(document).ready(function () {
  $(".details--list-menu").on("click", function (event) {
    event.preventDefault(); // Prevent default click behavior
  });
});

/* Home slider */
// $(document).ready(function(){
//   $('.cs-slide-main-banner').slick({
//     centerPadding: "0px",
//     dots: false,
//     slidesToShow: 1,
//     autoplay: false,
//     autoplaySpeed: 2000,
//     infinite: false,
//     arrows: false,
//     dragable: true
//   });
// });

/* Product tracker */
const progress = document.querySelector(".progress-done");
progress.style.width = progress.getAttribute("data-done") + "%";
progress.style.opacity = 1;

/* Custom quantity */
$(document).ready(function () {
  $(".qtyplus").click(function (e) {
    e.preventDefault();
    var quantityInput = $("#range-slider__value");
    var currentVal = parseInt(quantityInput.val());
    var maxVal = parseInt(quantityInput.attr("max"));

    if (!isNaN(currentVal) && currentVal < maxVal) {
      quantityInput.val(currentVal + 1);
      // Add any additional logic you need here
    }
  });

  $(".qtyminus").click(function (e) {
    e.preventDefault();
    var quantityInput = $("#range-slider__value");
    var currentVal = parseInt(quantityInput.val());
    var minVal = parseInt(quantityInput.attr("min"));

    if (!isNaN(currentVal) && currentVal > minVal) {
      quantityInput.val(currentVal - 1);
      // Add any additional logic you need here
    }
  });
});

$(document).ready(function () {
  // Function to handle checkbox change
  $("input[type='checkbox']").on("change", function () {
    // Uncheck all checkboxes except the current one
    $("input[type='checkbox']").not(this).prop("checked", false);
    // Toggle the 'checked' attribute on the current checkbox
    $(this).attr("checked", this.checked);
  });
});
 
/* Product tab */
$(document).ready(function () {
  // Add "active" class to the first tab link and corresponding tab content
  $(".tab_block_main ul li:first-child a").addClass("active");
  $(".tab_block_main .tab_block:first-child").addClass("active");

  // Click event handler for tab links
  $(document).on("click", ".tab_block_main ul li a", function (e) {
    var curTabContentId = $(this).attr("href");
    $(this).parents(".tab_block_main").find("ul li a").removeClass("active");
    $(this).addClass("active");
    $(this)
      .parents(".tab_block_main")
      .find(".tab_content .tab_block")
      .removeClass("active");
    $(curTabContentId).addClass("active");
    e.preventDefault();
  });
});
